import { returnReconciliationTableColumns } from "@/components/stock/return-reconciliation-table/table-config";
import { useReturnReconciliation } from "@/hooks/use-return-reconciliation";
import { DataTable } from "@msuite/ui/table";

/** Props Interface */
interface ReturnOrderReconciliationProps {
	returnOrderId: string;
}

/**
 * The account of the run's project: what went out, what has come back, what is still on site.
 *
 * This is the list the returner works through. It is derived rather than stored — a return order
 * declares no lines in advance, because what comes back is whatever was standing on the site.
 */
export function ReturnOrderReconciliation({ returnOrderId }: ReturnOrderReconciliationProps) {
	/** Query */
	const { reconciliation, isLoading, refetch, queryKey } = useReturnReconciliation(returnOrderId);

	/** Render */
	return (
		<DataTable
			data={reconciliation}
			columns={returnReconciliationTableColumns}
			queryKey={queryKey}
			isLoading={isLoading}
			refetch={refetch}
			persistenceKey="reconciliation-table"
			initialPinningState={{ end: ["outstandingQuantity"] }}
			menu={null}
		/>
	);
}
